import { render, staticRenderFns } from "./TabsV3.vue?vue&type=template&id=f2bb6de8&scoped=true&"
import script from "./TabsV3.vue?vue&type=script&lang=ts&"
export * from "./TabsV3.vue?vue&type=script&lang=ts&"
import style0 from "./TabsV3.vue?vue&type=style&index=0&id=f2bb6de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bb6de8",
  null
  
)

export default component.exports